import { ApiEndpoints } from "@shared/api/api-endpoints";
import { wxApiClient } from "@shared/api/clients/apiClientFactory";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";

export const getElectricUnit = async () => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "wx",
    "choices/electric_unit"
  );

  const response = await wxApiClient.get(url);
  return response.data.result;
};

export const getFlowCapacityUnit = async () => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "wx",
    "choices/flow_capacity_unit"
  );

  const response = await wxApiClient.get(url);
  return response.data.result;
};


 export const getActivityLog = async (id: string, type: string) => {
      const url = ApiEndpoints.createUrlWithQueryParameters(
        "mx",
        `activity-log`,
        (query) => {
          query.push("remote_utility_id", getRemoteUtilityId());
          query.push("patient_id", id);
          query.push("entity_type", type);
          return query;
        }
      );
      const response = await wxApiClient.get(url);
      return response.data ?? [];
    };


